import { Component } from '@angular/core';

@Component({
  selector: 'bs-sw-logo-text-icon',
  imports: [],
  template: `
    <svg class="icon-fill w-full" height="40px" width="113px" id="bsSwLogoTextIconId" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 565 200">
      <defs>
        <style>
          .bs-sw-logo-text-cls-1 {
            fill: #000000;
            font-family: NasalizationRg-Regular, Nasalization !important;
            font-size: 100pt;
            stroke: #000000;
            stroke-miterlimit: 10;
            stroke-width: .25px;
          }
        </style>
      </defs>
      <text class="bs-sw-logo-text-cls-1" transform="translate(32.56 123.27)">
        <tspan x="0" y="0">Steelworks</tspan>
      </text>
    </svg>
  `,
  styles: `.icon-fill{

  }`,
  standalone: true
})
export class BsSwLogoTextComponent {

}
